'use client';

import useAuth from '@/hooks/useAuth';
import { AvatarProps, MenuLinkProps, MenuProps } from './types';
import Link from '@/components/Link';
import Popover from '@/components/Popover';
import { GuestMenu, UserMenu } from './constants';
import { useContext } from 'react';
import HeaderContext, { HeaderContextType } from '@/context/HeaderContext';
import clsx from 'clsx';

import styles from './UserBar.module.css';
import { User } from '@/types/User';

const Menu = ({ menuLinks, logout }: MenuProps) => {
  return (
    <ul className={styles.userAccountList} data-testid={'userbar-menu'}>
      {menuLinks.map((link: MenuLinkProps, idx) => {
        return (
          <li key={idx}>
            <Link data-testid={`menu-link-${link.title}`} href={link.url} showCursorPointer={true} classes={styles.popoverLink}>
              {link.title}
            </Link>
          </li>
        );
      })}
      {logout && (
        <li>
          <Link data-testid={'menu-logout-btn'} onClick={() => logout()} showCursorPointer={true} classes={styles.popoverLink}>
            Logout
          </Link>
        </li>
      )}
    </ul>
  );
};

const Avatar = ({ id, fullName = '' }: AvatarProps) => {
  const abbreviation = fullName
    .split(' ')
    .map((initials) => initials.charAt(0))
    .join('');

  return (
    <div id={id} className={clsx(styles.avatar, `${fullName === '' ? styles.guest : styles.logged}`)}>
      {fullName !== '' && <div className={styles.abbrevation}>{abbreviation}</div>}
    </div>
  );
};

const UserBar = ({ userData }: { userData: User | null }) => {
  const { user, logout } = useAuth(userData);
  const { height } = useContext(HeaderContext) as HeaderContextType;

  return (
    <Popover
      id={user ? 'registered-menu' : 'guest-menu'}
      headerHeight={height}
      anchorComponent={
        <div data-testid={'userbar-popover-anchor'} className={user ? styles.greetingContainer : styles.personalLink}>
          <Avatar
            id={user ? 'registered-avatar' : 'guest-avatar'}
            fullName={user ? `${user?.firstName} ${user?.lastName}` : ''}
          />
        </div>
      }
      isHeaderPopover={true}
      containerClassName={styles.popoverContainer}
      contentClassName={styles.popoverContent}
      popoverContent={user ? <Menu menuLinks={UserMenu} logout={logout} /> : <Menu menuLinks={GuestMenu} />}
    />
  );
};

export default UserBar;
